import { useEffect, useState } from "react";
import { GameBanAPI, IGameBan } from "../../api/admin/game-ban";
import { FormProps } from "../../components/form/interface/formInterface";
import DivStyle from "../../components/style/div.component";
import SmallForm from "../../components/form/small_form";
import ButtonStyle from "../../components/style/button.component";
import Icon from "@mdi/react";
import { mdiMagnify } from "@mdi/js";
import InputFormStyle from "../../components/style/input_form.component";
import Page from "../../components/table/paging";
import Table from "../../components/table/Table";
import { formatDate } from "../club/utils/excelExport";
const headers = [
  {
    text: "ID",
    align: "center",
    sortable: false,
    value: "id",
  },
  {
    text: "닉네임",
    align: "center",
    sortable: false,
    value: "nickname",
  },
  {
    text: "전화번호",
    align: "center",
    sortable: false,
    value: "phoneNumber",
  },
  {
    text: "아이디",
    align: "center",
    sortable: false,
    value: "textId",
  },
  {
    text: "메모",
    align: "center",
    sortable: false,
    value: "memo",
  },
  {
    text: "등록일시",
    align: "center",
    sortable: false,
    value: "createdAt",
  },
];

const GameBan = () => {
  const [gameBanList, setGameBanList] = useState<IGameBan[]>([]);
  const [searchGameBanList, setSearchGameBanList] = useState<IGameBan[]>([]);
  const [searchNickname, setSearchNickname] = useState("");
  const [searchMemo, setSearchMemo] = useState("");

  const [mode, setMode] = useState("I");

  const [id, setId] = useState(0);
  const [nickname, setNickname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [textId, setTextId] = useState("");
  const [memo, setMemo] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const formData: FormProps = {
    title: "벤 등록",
    form: [
      {
        value: searchNickname,
        setValue: setSearchNickname,
        label: "닉네임",
        width: "100%",
        type: "input",
      },
      {
        value: searchMemo,
        setValue: setSearchMemo,
        label: "메모",
        width: "100%",
        type: "input",
      },
    ],
  };

  const formData2: FormProps = {
    title: "상세 정보",
    form: [
      {
        value: nickname,
        setValue: setNickname,
        label: "닉네임",
        width: "100%",
        type: "input-dash",
      },
      {
        value: phoneNumber,
        setValue: setPhoneNumber,
        label: "전화번호",
        width: "100%",
        type: "input-dash",
      },
      {
        value: textId,
        setValue: setTextId,
        label: "아이디",
        width: "100%",
        type: "input-dash",
      },
      {
        value: memo,
        setValue: setMemo,
        label: "메모",
        width: "100%",
        type: "input-dash",
      },
    ],
  };

  const maskPhoneNumber = (phoneNumber: string): string => {
    if (!phoneNumber) return "";

    const numbersOnly = phoneNumber.replace(/\D/g, "");

    if (numbersOnly.length < 4) return phoneNumber;

    const maskedNumbers = numbersOnly.slice(0, -4) + "****";

    if (phoneNumber.includes("-")) {
      if (maskedNumbers.length === 11) {
        return maskedNumbers.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
      } else if (maskedNumbers.length === 10) {
        return maskedNumbers.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      }
    }

    return maskedNumbers;
  };

  const getGameBanList = async () => {
    const res = await GameBanAPI.getGameBanList();

    const updatedList = res.data.map((item: IGameBan) => ({
      ...item,
      createdAt: formatDate(item.createdAt),
      phoneNumber: maskPhoneNumber(item.phoneNumber),
    }));
    setTotalPages(Math.ceil(updatedList.length / 10));
    setGameBanList(updatedList);
    setSearchGameBanList(updatedList);
  };

  const handleSearch = (search: string) => {
    const filteredList = gameBanList.filter((item) =>
      item.nickname.includes(search)
    );
    setSearchGameBanList(filteredList);
  };

  const add = async () => {
    try {
      await GameBanAPI.registerGameBan({
        nickname: searchNickname,
        memo: searchMemo,
      });
      alert("등록되었습니다.");
      await getGameBanList();
    } catch (error: any) {
      console.log(error);
      alert(error.response.data.message);
    }
  };

  const remove = async () => {
    if (id === 0) return;
    try {
      await GameBanAPI.deleteGameBan(id);
      await getGameBanList();
      alert("삭제되었습니다.");
    } catch (error: any) {
      console.log(error);
      alert(error.response.data.message);
    }
  };

  const addForm = () => {
    setMode("I");
    setId(0);
    setNickname("");
    setPhoneNumber("");
    setTextId("");
    setMemo("");
  };

  const detail = (item: IGameBan) => {
    setId(item.id);
    setNickname(item.nickname);
    setPhoneNumber(item.phoneNumber);
    setTextId(item.textId);
    setMemo(item.memo || "");
  };

  useEffect(() => {
    getGameBanList();
  }, []);

  return (
    <DivStyle
      style={{ overflow: "auto" }}
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="row"
      marginTop="65px"
      setMobile={true}
    >
      <DivStyle
        width="66%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileTable={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
          게임 벤 관리
        </h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="10px"
        >
          <DivStyle
            width="100%"
            display="flex"
            flex_direction="row"
            justify_content="end"
            align_items="center"
          >
            <DivStyle
              width="50%"
              display="flex"
              justify_content="flex-end"
              flex_direction="row"
              align_items="center"
              marginRight="20px"
              marginTop="20px"
            >
              <InputFormStyle
                onChange={(e) => handleSearch(e.target.value)}
              ></InputFormStyle>
              <Icon path={mdiMagnify} size={1} style={{ color: "white" }} />
            </DivStyle>
          </DivStyle>
          <Table
            headers={headers}
            currentPage={currentPage}
            dataList={searchGameBanList}
            setDetail={detail}
          />
          <Page
            currentPage={currentPage}
            totalPages={totalPages}
            dataList={searchGameBanList}
            setCurrentPage={setCurrentPage}
          />
        </DivStyle>
        <DivStyle
          marginBottom="50px"
          width="95%"
          display="flex"
          justify_content="flex-end"
        >
          <ButtonStyle
            border="none"
            backgroundColor="#1976D2"
            width="85px"
            height="40px"
            color="white"
            borderRadius="5px"
            onClick={() => addForm()}
          >
            신규 등록
          </ButtonStyle>
        </DivStyle>
      </DivStyle>
      <DivStyle
        width="33%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileForm={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>폼</h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <SmallForm
            form={formData.form}
            title={formData.title}
            add={add}
            mode={mode}
          />
          <SmallForm
            form={formData2.form}
            title={formData2.title}
            add={add}
            remove={remove}
            mode={"NU"}
          />
        </DivStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default GameBan;
